import React,{ Component } from "react";
import ManageLayout from "../../../../common/report/details/manage-report.component";
import { CustomDropdown } from "../../../../common/custom-form/custom-dropdown.component";
import AccountLocationAddress from "./account-location-details.componet";
import AccountLocationRemit from "./account-location-remit.component";
import AccountAuditRules from "./account-audit.rules.component";
import { AccountCostAllocation } from "./account-cost-allocation.component";
import { AccountPurchaseOrder } from "./account-purchase.component";
import { DetailsInfo } from "./account-details-info.component";
import { ListTabButton } from "../../../../common/list-tab/list-tab-button.component";
import { Button } from "react-bootstrap";
import   InvoiceHistory  from "../../../../common/report/reports/Invoice/manage-invoice/invoice-history.component";
import InvoiceComment from "../../../../common/report/reports/Invoice/manage-invoice/invoice-comment.component";
import { Selected_Index } from "../../../../../constants/internal-constants";
import { DetailList } from "../details-list/details-list.component";
export default class AccountDetails extends Component{
    constructor(props){
        super(props);
        this.getDataSelected=this.getDataSelected.bind(this);
        this.openCircuitView=this.openCircuitView.bind(this);
        this.state={
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
            filterSelected: "", 
            inputValue: "",
            invoiceDate: "",
            invoiceApproveDate: "",
            invoiceDueDate: "",
            billingPeriodDate: "",
            invoiceExpectedDate: "",
            rentalPeriodDate: "",
            actualInvoiceMonth: "",
            invoiceReceiptDate: "",
            beginDate: "",
            endDate: "",
            showOrderSummary: false,
            openCircuitDetails:false,
            dataTable:[
                {              
                    HeaderItem:[
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }
                    ],
                    dataItem:[{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"                       
                    }, {            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    },{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    }        
                    ]
    
                }
            ],
            
            selectedIndex:"0", 
            dataSelected:0,
            tableSelected:false,
            listTabInfo:{
                Tab:[
                    {
                        "id":"0",
                        "label":"Details"            
                    },
                    {
                        "id":"1",
                        "label":"History"           
                    },
                    {
                        "id":"2",
                        "label":"Comments"           
                    }
                ]
            },
            dataInfo:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0",
                         "Order Submit Date: From: May 31, 2021 at 4:00PM TO: June 07, 2021 at 4:00 AM",
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],
            commentData:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0"                         
                     ]
                },
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[                         
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],
            statusList:[
                {
                    "status":"Order Created",
                    "dateCompleted": "29/09/2022"
                },
                {
                    "status":"Order Submitted"                
                },
                {
                    "status":"Order Receipt Confirmed"                    
                },
                {
                    "status":"Circuit Installed"                    
                }

            ]

        }
    }

    getDataSelected(data) {
        this.setState({selectedIndex:data})
       
    }

    openLineItem(data) {
        this.setState({tableSelected:data})
    }

    openCircuitView(value){
       
        this.setState({openCircuitDetails:value})   
        this.setState({showOrderSummary:false})  
        this.setState({selectedIndex:"0"})   
    }

    FilterIndex(tabIndex){    
        this.setState({selectedIndex:tabIndex});  
       
    }

    render(){        
        return(
            <>
            {
                <ManageLayout customClassName="manage-order-table finance-detail-table" buttonLabel="Back"  haveStatusLabel={false} onGetSelected={this.getDataSelected.bind(this)} statusList={this.state.statusList} closeForm={this.props.closeForm} haveHeaderButton={false}>
                 <ListTabButton listData={this.state.listTabInfo.Tab} selectedIndex={this.props.haveTotalDetail ? this.state.selectedTab : this.state.selectedIndex} FilterIndex={this.FilterIndex.bind(this)}/>
                {
                  this.state.selectedIndex===Selected_Index.i_Zero &&
                   <>                      
                        <div className="manage-order-container">
                            <DetailsInfo customClass="manage-order-detail"/>
                        </div>
                        <div className="horizontal-separator"></div>
                        <div>                            
                            <DetailList/>
                        </div>
                           
                        <div className="save-btn-container">                            
                            <Button className="save-button"> Save Changes </Button>                                   
                        </div>                                
                 </>                 
                        
                }

                {
                    this.state.selectedIndex===Selected_Index.i_One &&
                    < InvoiceHistory dataInfo={this.state.dataInfo} noMessage="No History Available"/>
                    
                }

                {
                    this.state.selectedIndex===Selected_Index.i_Two &&
                    <InvoiceComment dataInfo={this.state.commentData} noMessage="No Comment Available"/>
                }

            </ManageLayout>
            }
           
            </>
        )
    }
}